import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import AdminLayout from "../../../components/admin/common/AdminLayout";
import ViewExamFragment from "../../../components/admin/exam/ViewExamFragment";
import { clearExamData } from "../../../redux/slice/examsSlice";

const ViewExam = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(clearExamData());
    };
  }, [dispatch]);
  return (
    <AdminLayout>
      <ViewExamFragment />
    </AdminLayout>
  );
};

export default ViewExam;
